import BusIcon from "../../components/shared/icons/busIcon";

const CallCenterDashboard = [
    {
        path: "dashboard",
        fullPath: "call-center/dashboard",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Dashboard",
        displayPath: "Call Center > Dashboard",
        icon: BusIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/CallCenter/Dashboard"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["callcenter-dashboard-view"],
            },
        ],
    },
];

export default CallCenterDashboard;
